import * as React from 'react';
import MUIDataTable, { Responsive } from 'mui-datatables';
import InvoiceService from 'src/services/invoice';
import './TableInvoice.scss';
import CustomPaginator from '../common/CustomPaginator';
import exportIcon from '../../assets/export';
import saveFileIcon from '../../assets/saveFileIcon';
import emailIcon from '../../assets/emailIcon';
import downarrowIcon from '../../assets/downArrow';
import LocaleFormating from 'src/translation/localeFormating';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from '../../themes/theme';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import { downloadFile } from 'src/utils/downloadHelper';
import creditDollar from '../../assets/creditDollar';
import debitIcon from '../../assets/debitIcon';
import { Alert } from '@material-ui/lab';
import { IconButton, Tooltip } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import * as _ from 'lodash';
import env from 'src/shared/env';
import Downloadloader from 'src/components/common/Downloadloader';
import warningIcon from '../../assets/images/warning-sign.svg';
import * as ReactDOM from 'react-dom';
import { disableScroll, enableScroll } from 'src/utils/documentInteraction';

// Components imports
import EmailInvoicesApplyCreditModel from '../../../src/components/Invoices/components/EmailInvoicesApplyCreditModel';

import Modal from 'src/components/common/Modal';
import i18n from 'src/translation/i18n';

function EnhancedTable(props: any, IInvoiceFiltersState: any) {
  const [transitionTime, setTransitionTime] = React.useState(300);
  const [pagenumber, setPagenumber] = React.useState(0);
  const [pagesize, setPageSize] = React.useState(0);
  const [rowscount, setRowscount] = React.useState([]);
  const [creditamount, setCreditamount] = React.useState(0);
  const [debitamount, setDebitamount] = React.useState(0);
  const [selectedImproperData, setSelectedImproperData] = React.useState([]);
  const [selectedData, setSelectedData] = React.useState([]);
  const [allSelectedData, setAllSelectedData] = React.useState([]);
  const [
    removeInvoiceFromSelected,
    setRemoveInvoiceFromSelected
  ] = React.useState([]);
  const [disabledbtn, setDisabledbtn] = React.useState(false);
  const [paydisabledbtn, setPaydisabledbtn] = React.useState(false);
  const [creditdata, setCreditdata] = React.useState([]);
  const [hidepay, setHidepay] = React.useState(false);
  const [hideBtnShowError, setHideBtnShowError] = React.useState('');
  const [hideShowPdfError, setHideShowPdfError] = React.useState(false);
  const [showInvoiceError, setShowInvoiceError] = React.useState(false);
  const [showSelectCredit, setShowSelectcredit] = React.useState(false);
  const [showLoaderOnAction, setShowLoaderOnAction] = React.useState(false);
  const [
    showDownloadLoaderOnAction,
    setDownloadShowLoaderOnAction
  ] = React.useState(false);
  const [showContinue, setShowcontinue] = React.useState(false);
  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [continueDisabledbtn, setContinueDisabledbtn] = React.useState(false);
  const [showCustomToolBar, handleShowCustomToolBar] = React.useState(true);
  const [displayState, setDisplayState] = React.useState([]);
  const [sortOrderState, setSortOrderState] = React.useState({
    name: 'invoiceDate',
    direction: 'asc'
  });
  const exportOptions = [
    { label: `${i18n.t('invoices.exportasXLSX')}`, value: 'xlsx' },
    { label: `${i18n.t('invoices.exportasPDF')}`, value: 'pdf' },
    { label: `${i18n.t('invoices.exportasCSV')}`, value: 'csv' }
  ];

  console.log("Develop prod testing >>>>");

  // Document Types of Invoices
  const paymentsDocTypeIcons = [
    'CFD',
    'CRA',
    'OFF',
    'RCH',
    'RCK',
    'R02',
    'R09',
    'R50',
    'R51',
    'R60',
    'R03',
    'R01',
    'RCC'
  ];
  const debitInvoicesDocType = ['ARI', 'IND', 'INS', 'NFC', 'NSF', 'SVC','CFD'];
  const creditInvoicesDocType = ['ARD'];
  const bothCreditDebit = ['D98', 'D99', 'DMI','DMC','R01','R03','R09','R10','RCC','R60','AMI','AMC','A99','A01'];
  const allInvoiceSelections: any[] = [];

  /* 
    openEmailModal
   */
  const openEmailModal = () => {
    if (allSelectedData.length > 0) {
      setModalIsOpen(true);
      window.scrollTo(0, 0);
      disableScroll();
    }
  };

  /* 
    closeEmailModal
   */
  const closeEmailModal = () => {
    setModalIsOpen(false);
    enableScroll();
  };
  const removeInvoiceFromSelectedVal = (select: any) => {
    console.log('removeInvoiceFromSelectedVal>>>>>>', select);
  };
  const getEmailModal = () => {
    return (
      <React.Fragment>
        <div className="send-email-desktop">
          {modalIsOpen ? (
            <Modal showClose={true} handleCloseModal={closeEmailModal}>
              <EmailInvoicesApplyCreditModel
                selectedInvoices={allSelectedData}
                removeInvoiceFromSelectedVal={removeInvoiceFromSelected}
                closeModal={closeEmailModal}
              />
            </Modal>
          ) : (
            <React.Fragment />
          )}
        </div>
      </React.Fragment>
    );
  };
  const handleEmailListItem = () => {
    // if (allSelectedData && allSelectedData.length > 0) {
    //   const selectedInvoices: any[] = [];
    //   allSelectedData.map(sel => {
    //     const isExist = selectedInvoices.filter(
    //       a => a.invoiceNo === sel.invoiceNumber.toString()
    //     );
    //     if (isExist.length === 0) {
    //       selectedInvoices.push({
    //         invoiceNo: sel.invoiceNumber.toString(),
    //         invoiceDate: sel.invoiceDate.toString()
    //       });
    //     }
    //   });
    //   InvoiceService.downloadInvoices(selectedInvoices).then((response: any) => {
    //     if (selectedInvoices.length === 1) {
    //       downloadFile(
    //         response.data,
    //         `invoice-${
    //           selectedInvoices[0].invoiceNumber
    //         }-${LocaleFormating.getNowDate('short')}.pdf`
    //       );
    //     } else {
    //       downloadFile(
    //         response.data,
    //         `invoices${LocaleFormating.getNowDate('short')}.zip`
    //       );
    //     }
    //   });
    // }
  };
  const handleDownloadListItem = () => {
    if (allSelectedData && allSelectedData.length > 0) {
      const selectedInvoices: any[] = [];
      // const selectedInvoiceList: string[] = [];
      allSelectedData.map(sel => {
        const isExist = selectedInvoices.filter(
          a => a.invoiceNo === sel.invoiceNumber.toString()
        );
        if (isExist.length === 0) {
          selectedInvoices.push({
            invoiceNo: sel.invoiceNumber.toString(),
            invoiceDate: sel.invoiceDate.toString()
          });
          // selectedInvoiceList.push(sel.invoiceNumber.toString());
        }
      });
      if (selectedInvoices && selectedInvoices.length > 0) {
        setShowLoaderOnAction(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        InvoiceService.downloadInvoices(selectedInvoices)
          .then((response: any) => {
            setShowLoaderOnAction(false);
            setShowInvoiceError(false);
            if (response.status === 206) {
              setShowInvoiceError(true);
            }
            // console.log(
            //   'response.headers',
            //   response.headers,
            //   selectedInvoices.length
            // );
            // if (response.headers && response.headers.invoicefilesstatus) {
            //   const headerJson = JSON.parse(
            //     response.headers.invoicefilesstatus
            //   );
            //   console.log(
            //     'headerJson',
            //     headerJson.invoiceFilesStatus.found.length,
            //     selectedInvoices.length,
            //     headerJson
            //   );
            //   if (
            //     headerJson.invoiceFilesStatus.found.length <
            //     selectedInvoices.length
            //   ) {
            //     // const found = headerJson.invoiceFilesStatus.found;
            //     // const notFound = selectedInvoiceList.filter(
            //     //   el => !found.includes(el)
            //     // );
            //     console.log(
            //       'found',
            //       headerJson.invoiceFilesStatus.found.length,
            //       selectedInvoices.length
            //     );
            //     setShowInvoiceError(true);
            //     console.log(
            //       'found error',
            //       headerJson.invoiceFilesStatus.found.length,
            //       selectedInvoices.length
            //     );
            //     // setHideBtnShowError(
            //     //   `${i18n.t(
            //     //     'invoices.message10'
            //     //   )} ${notFound.toString().replace(/,/g, ', ')}. ${i18n.t(
            //     //     'invoices.message11'
            //     //   )}`
            //     // );
            //   }
            // }
            if (selectedInvoices.length === 1) {
              downloadFile(
                response.data,
                `invoice-${
                  allSelectedData[0].invoiceNumber
                }-${LocaleFormating.getNowDate('short')}.pdf`
              );
            } else {
              downloadFile(
                response.data,
                `invoices${LocaleFormating.getNowDate('short')}.zip`
              );
            }
          })
          .catch(error => {
            console.log(error);
            setShowInvoiceError(true);
            setShowLoaderOnAction(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          });
      }
    }
  };
  const handleDwnClose = (rowIndex: any) => {
    document.getElementById(`errId_${rowIndex}`).remove();
  };

  const onClickInvoiceNo = (tablemeta: any) => {
    setDownloadShowLoaderOnAction(true);
    const rowIndex = tablemeta.rowIndex;
    const errId = document.getElementById(`errId_${rowIndex}`);
    if (errId) {
      errId.parentNode.removeChild(errId);
    }
    InvoiceService.downloadInvoice(tablemeta.rowData[0], tablemeta.rowData[2])
      .then((response: any) => {
        setHideShowPdfError(false);
        setDownloadShowLoaderOnAction(false);
        downloadFile(
          response.data,
          `invoice-${tablemeta.rowData[0]}-${LocaleFormating.getNowDate(
            'short'
          )}.pdf`
        );
      })
      .catch(error => {
        console.log(error);
        setHideShowPdfError(true);
        setDownloadShowLoaderOnAction(false);
        // window.scrollTo({ top: 0, behavior: 'smooth' });
        /* Show error message */
        const el: HTMLElement = document.querySelector(
          `[data-testid="MUIDataTableBodyRow-${rowIndex}"]`
        );
        const newErrorRowElement = document.createElement('tr');
        newErrorRowElement.setAttribute('id', `errId_${rowIndex}`);
        const newErrorTdElement = document.createElement('td');
        newErrorTdElement.setAttribute('colspan', '12');
        newErrorTdElement.setAttribute('id', `tdId_${rowIndex}`);
        newErrorTdElement.setAttribute('class', 'errorDwnClass');
        newErrorRowElement.appendChild(newErrorTdElement);
        el.parentNode.insertBefore(newErrorRowElement, el);
        ReactDOM.render(
          <Alert
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => handleDwnClose(rowIndex)}
              >
                <MatrialCloseIcon fontSize="inherit" />
              </IconButton>
            }
            severity="error"
          >
            <div>
              <div className="error-message-to-show">
                {i18n.t('invoices.downloaderror')}
              </div>
            </div>
          </Alert>,
          document.getElementById(`tdId_${rowIndex}`)
        );
      });
  };

  // tablemeta.rowData[9] <= 0 ? 'Credit Invoice' : 'Debit Invoice'
  const getInvoiceImages = (tablemeta: any, value: any, isImage: boolean) => {
    if (paymentsDocTypeIcons.includes(tablemeta.rowData[12])) {
      return '';
    } else if (
      tablemeta.rowData[9] > 0 &&
      (debitInvoicesDocType.includes(tablemeta.rowData[12]) ||
        bothCreditDebit.includes(tablemeta.rowData[12]))
      // debitInvoicesDocType.includes(tablemeta.rowData[12]) ||
      // (bothCreditDebit.includes(tablemeta.rowData[12]) && value > 0)
    ) {
      return isImage ? (
        <img className="icon-position" src={debitIcon} />
      ) : (
        `${i18n.t('invoices.debitInvoice')}`
      );
    } else if (
      tablemeta.rowData[9] < 0 &&
      (creditInvoicesDocType.includes(tablemeta.rowData[12]) ||
        bothCreditDebit.includes(tablemeta.rowData[12]))

      // creditInvoicesDocType.includes(tablemeta.rowData[12]) ||
      // (bothCreditDebit.includes(tablemeta.rowData[12]) && value <= 0)
    ) {
      return isImage ? (
        <img className="icon-position" src={creditDollar} />
      ) : (
        `${i18n.t('invoices.creditInvoice')}`
      );
    }
    return '';
  };
  const checkDisplayState = (
    fileldName: string,
    state: boolean,
    isUpdate: boolean
  ) => {
    const stateList = displayState;
    let stateVal = state;
    if (isUpdate) {
      stateList[fileldName] = state ? 'add' : 'remove';
      if(stateList[fileldName]==="add"){
        if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
        localStorage.setItem(fileldName, "col-checked");
        }else{
          localStorage.setItem(fileldName, "ca-col-checked");  
        } 
      }else{
        if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
        localStorage.setItem(fileldName, "col-unchecked"); 
        }else{
          localStorage.setItem(fileldName, "ca-col-unchecked"); 
        }
      }
    } else {
      const colsStatus = localStorage.getItem(fileldName);
      if (stateList[fileldName]) {
        
        if (env.REACT_APP_BASE_ENVIRONMENT !== 'CA') {
        if(colsStatus==="col-unchecked"){
          stateVal = stateList[fileldName] === 'add' ? false : true;
        }else{
        stateVal = stateList[fileldName] === 'add' ? true : false;
        }
      }else{

        if(colsStatus==="ca-col-unchecked"){
          stateVal = stateList[fileldName] === 'add' ? false : true;
        }else{
        stateVal = stateList[fileldName] === 'add' ? true : false;
        }

      }
      } else {
        stateList[fileldName] = state ? 'add' : 'remove';
      }
    }
    if (!_.isEqual(displayState, stateList)) {
      setDisplayState(stateList);
    }
    return stateVal;
  };

  const columns = [
    {
      label: `${i18n.t('invoices.invoiceNum')}`,
      name: 'invoiceNumber',
      options: {
        filter: false,
        display: checkDisplayState('invoiceNumber', true, false),
        customBodyRender: (value: any, tablemeta: any) => {
          return (
            <label>
              <span
                className="invoice-under-line"
                onClick={() => onClickInvoiceNo(tablemeta)}
              >
                {value}
              </span>
              <Tooltip
                title={getInvoiceImages(tablemeta, value, false)}
                placement="right"
              >
                <span>{getInvoiceImages(tablemeta, value, true)}</span>
              </Tooltip>
            </label>
          );
        }
      }
    },
    /*{
      label: `${i18n.t('invoices.transactionId')}`,
      name: 'transactionId',
      options: { display: 'excluded' }
    },*/
    {
      label: `${i18n.t('invoices.transactionId')}`,
      name: 'transactionId',
      options: { display: false }
    },
    {
      label: `${i18n.t('invoices.invoiceDate')}`,
      name: 'invoiceDate',
      options: { display: checkDisplayState('invoiceDate', true, false) }
    },
    {
      label: `${i18n.t('invoices.orderNo')}`,
      name: 'orderNumber',
      options: { display: checkDisplayState('orderNumber', true, false) }
    },
    {
      label: `${i18n.t('invoices.poNo')}`,
      name: 'orderReference',
      options: { display: checkDisplayState('orderReference', true, false) }
    },
    {
      label: `${i18n.t('invoices.description')}`,
      name: 'description',
      options: { display: checkDisplayState('description', true, false) }
    },
    {
      label: `${i18n.t('invoices.oriInvNo')}`,
      name: 'previousInvoice',
      options: { display: checkDisplayState('previousInvoice', true, false) }
    },
    /*
    {
      label: `${i18n.t('invoices.nardaNo')}`,
      name: 'nardaNumber',
      options: {
        display:
          env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? 'excluded'
            : checkDisplayState('nardaNumber', true, false)
      }
    },*/
    {
      label: `${i18n.t('invoices.nardaNo')}`,
      name: 'nardaNumber',
      options: {
        display:
          env.REACT_APP_BASE_ENVIRONMENT === 'CA'
            ? false
            : checkDisplayState('nardaNumber', true, false)
      }
    },
    {
      label: `${i18n.t('invoices.totalAmt')}`,
      name: 'totalAmount',
      options: {
        display: checkDisplayState('totalAmount', true, false),
        filter: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {parseFloat(value).toFixed(2)}</label>;
          return <label>{currencyFormatter(value)}</label>;
        }
      }
    },
    {
      label: `${i18n.t('invoices.remAmt')}`,
      name: 'remainingAmount',
      options: {
        display: checkDisplayState('remainingAmount', true, false),
        filter: false,
        customBodyRender: (value: any, tablemeta: any) => {
          // return <label>$ {parseFloat(value).toFixed(2)}</label>;
          return <label>{currencyFormatter(value)}</label>;
        }
      }
    },
    {
      label: `${i18n.t('invoices.filters.dueDate')}`,
      name: 'dueDate',
      options: { display: checkDisplayState('dueDate', true, false) }
    },
    {
      label: `${i18n.t('invoices.filters.status')}`,
      name: 'status',
      options: {
        display: checkDisplayState('status', true, false),
        filter: false,
        customBodyRender: (value: any, tablemeta: any) => {
          if (value === 'PAST DUE') {
            return <label className="orange">{value}</label>;
          } else if (value === 'DUE TODAY') {
            return <label className="blue">{value}</label>;
          } else if (value === 'PAID') {
            return <label className="paid-status">{value}</label>;
          } else if (value === 'PENDING') {
            return (
              <Tooltip
                title={i18n.t('invoices.paidUsingCredits')}
                placement="bottom"
              >
                <label className="pending-status">{value}</label>
              </Tooltip>
            );
          } else if (value === 'OPEN') {
            return <label className="open-status">{value}</label>;
          } else if (value === 'IN PROCESS') {
            return (
              <Tooltip
                title={i18n.t('invoices.paidUsingCreditCard')}
                placement="bottom"
              >
                <label className="inprocess-status">{value}</label>
              </Tooltip>
            );
          } else {
            return <label>{value}</label>;
          }
        }
      }
    },
    {
      label: `${i18n.t('invoices.doc')}`,
      name: 'documentType',
      options: {
        display: checkDisplayState('documentType', false, false)
      }
    }
  ];
  const invoice = (tablemeta: any) => {
    console.log('invoicenumber');
  };
  React.useEffect(() => {
    setPagenumber(0);
  }, [props.filtervalues, pagesize]);

  const handlePagination = (newpage: number) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    let orderStatus = '';
    if (props.filtervalues) {
      orderStatus = props.filtervalues.orderStatus;
    }
    const filters: any = {
      dateRange: datesFilter,
      status: statusFilter,
      sort: sortFilter,
      orderStatus
    };
    if (newpage - 1 !== pagenumber) {
      setPagenumber(newpage - 1);
      const newPagination = {
        page: newpage - 1,
        size: pagesize
      };
      getInvoices(filters, newPagination);
    }
  };
  const handleSorting = (newSort: any) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    let orderStatus = '';
    if (props.filtervalues) {
      orderStatus = props.filtervalues.orderStatus;
    }
    const filters: any = {
      dateRange: datesFilter,
      status: statusFilter,
      sort: newSort,
      orderStatus
    };
    setPagenumber(0);
    const newPagination = {
      page: 0,
      size: pagesize
    };
    getInvoices(filters, newPagination);
  };
  const handlePageSizeChange = (pageSizeVal: any) => {
    const { datesFilter, statusFilter, sortFilter, pagination } = props;
    let orderStatus = '';
    if (props.filtervalues) {
      orderStatus = props.filtervalues.orderStatus;
    }
    const filters: any = {
      dateRange: datesFilter,
      status: statusFilter,
      sort: sortFilter,
      orderStatus
    };
    const newPagination = {
      page: 0,
      size: pageSizeVal
    };
    setPageSize(pageSizeVal);
    getInvoices(filters, newPagination);
  };
  const selectClick = () => {
    props.setSelectedInvoices(selectedData);
    props.history.push({
      pathname: '/invoices/manualCredit',
      state: {
        continue: false,
        selectedDebit: debitamount
      }
    });
  };
  const continueClick = () => {
    // const debitData: any = [];
    // const creditData: any = [];
    // // if (creditamount >= debitamount) {
    // // setHideBtnShowError('');
    // allSelectedData.forEach((ele: any) => {
    //   if (
    //     debitInvoicesDocType.includes(ele.documentType) ||
    //     (bothCreditDebit.includes(ele.documentType) && ele.remainingAmount > 0)
    //   ) {
    //     debitData.push(ele);
    //   } else if (
    //     creditInvoicesDocType.includes(ele.documentType) ||
    //     (bothCreditDebit.includes(ele.documentType) && ele.remainingAmount < 0)
    //   ) {
    //     creditData.push(ele);
    //   }
    // });

    props.setSelectedInvoices(selectedData);
    props.setSelectedCreditInvoices(creditdata);

    props.history.push({
      pathname: '/invoices/manualCredit',
      state: {
        continue: true,
        selectedDebit: debitamount,
        selectedCredit: creditamount
      }
    });

    // } else {
    //   setHideBtnShowError(
    //     'Make sure that the selected credit is greater or equal to debit.'
    //   );
    // }
  };

  const payRemaining = () => {
    props.setSelectedInvoices(selectedData);
    props.history.push({
      pathname: '/invoices/payRemaining',
      state: {
        debitAmount: debitamount
      }
    });
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickListItem = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event: any, index: number) => {
    const { filtervalues, pagination } = props;
    const newPagination = {
      page: pagination.pageNumber,
      size: pagination.pageSize
    };
    setAnchorEl(null);
    if (allSelectedData && allSelectedData.length > 0) {
      const selectedInvoices: any = [];
      allSelectedData.forEach(ele => {
        const newObj = {
          transactionId: '',
          invoiceNumber: '',
          previousInvoice: '',
          orderNumber: ''
        };
        newObj.transactionId = ele.transactionId;
        newObj.invoiceNumber = ele.invoiceNumber;
        newObj.previousInvoice = ele.previousInvoice;
        newObj.orderNumber = ele.orderNumber;
        selectedInvoices.push(newObj);
      });
      if (selectedInvoices && selectedInvoices.length > 0) {
        setShowLoaderOnAction(true);
        InvoiceService.exportSelectedInvoices(
          exportOptions[index].value,
          selectedInvoices
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            setHideShowPdfError(false);
            downloadFile(
              response.data,
              `SelectedInvoices_${LocaleFormating.getNowDate('short')}.${
                exportOptions[index].value
              }`
            );
          })
          .catch(error => {
            console.log(error);
            setHideShowPdfError(true);
            setShowLoaderOnAction(false);
          });
      }
    } else {
      if (exportOptions[index].value === 'pdf') {
        setShowLoaderOnAction(true);
        InvoiceService.downloadAll(
          `All_Invoices_${LocaleFormating.getNowDate('short')}.pdf`,
          exportOptions[index].value,
          filtervalues,
          newPagination
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            setHideShowPdfError(false);
            downloadFile(
              response.data,
              `All_Invoices_${LocaleFormating.getNowDate('short')}.pdf`
            );
          })
          .catch(error => {
            console.log(error);
            setHideShowPdfError(true);
            setShowLoaderOnAction(false);
          });
      } else if (exportOptions[index].value === 'xlsx') {
        setShowLoaderOnAction(true);
        InvoiceService.downloadAll(
          `All_Invoices_${LocaleFormating.getNowDate('short')}.xlsx`,
          exportOptions[index].value,
          filtervalues,
          newPagination
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            setHideShowPdfError(false);
            downloadFile(
              response.data,
              `All_Invoices_${LocaleFormating.getNowDate('short')}.xlsx`
            );
          })
          .catch(error => {
            console.log(error);
            setHideShowPdfError(true);
            setShowLoaderOnAction(false);
          });
      } else if (exportOptions[index].value === 'csv') {
        setShowLoaderOnAction(true);
        InvoiceService.downloadAll(
          `All_Invoices_${LocaleFormating.getNowDate('short')}.csv`,
          exportOptions[index].value,
          filtervalues,
          newPagination
        )
          .then((response: any) => {
            setShowLoaderOnAction(false);
            setHideShowPdfError(false);
            downloadFile(
              response.data,
              `All_Invoices_${LocaleFormating.getNowDate('short')}.csv`
            );
          })
          .catch(error => {
            console.log(error);
            setHideShowPdfError(true);
            setShowLoaderOnAction(false);
          });
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const clearClick = () => {
    setHideBtnShowError('');
    setRowscount([]);
    props.isChecked([]);
    setAllSelectedData([]);
  };
  const { invoiceData } = props;
  const { getInvoices } = props;
  React.useEffect(() => {
    getInvoices();
  }, []);

  const getSortedInvoiceList = (a: any, b: any) => {
    if (a.invoiceNumber < b.invoiceNumber) {
      return -1;
    }
    if (a.invoiceNumber > b.invoiceNumber) {
      return 1;
    }
    return 0;
  };

  React.useEffect(() => {
    // props.rowCountValue(true);
    const invoiceDataVal = props.invoiceData; // .sort(getSortedInvoiceList);
    const rowCountIndex: any[] = [];
    allSelectedData.forEach(val => {
      const index = invoiceDataVal.findIndex(
        (ele: any) =>
          ele.invoiceNumber === val.invoiceNumber &&
          ele.previousInvoice === val.previousInvoice
      );
      if (index > -1) {
        rowCountIndex.push(index);
      }
    });
    setRowscount(rowCountIndex);
  }, [props.invoiceData]);

  const CustomToolbar = () => {
    return (
      <div className="select-credits margintb10px">
        <div className="d-flex selected-items">
          <div className="d-flex number-of-items">
            <span className="items">
              {allSelectedData.length} {i18n.t('invoices.itemselected')}{' '}
            </span>
            <span className="mobile-view">
              {allSelectedData.length} {i18n.t('invoices.itemselected')}{' '}
            </span>
            <span className="clear-mg " onClick={clearClick}>
              {i18n.t('common.clear')}
            </span>
            <span className="margin  mobile-none">|</span>
          </div>

          <div className="d-flex mg-right number-of-items mobile-none">
            <span className="open-invoices">
              {i18n.t('invoices.selectedDebit')}:{' '}
            </span>
            <span className="credit-amount">
              {/* <b> {'$' + debitamount.toFixed(2)}</b> */}
              <b> {currencyFormatter(debitamount)}</b>
            </span>
          </div>

          <div className="d-flex number-of-items  mobile-none">
            <span className="open-invoices">
              {i18n.t('invoices.selectedCredit')}:{' '}
            </span>
            <span className="credit-amount">
              {/* <b>{'$' + creditamount.toFixed(2)}</b> */}
              <b>{currencyFormatter(creditamount)}</b>
            </span>
          </div>
        </div>
        <div className="d-flex justify-flex-end">
          {/* <button
            className={`btn btn-width ${hidepay ? 'display-block' : 'display'}`}
            disabled={paydisabledbtn}
            onClick={payRemaining}
          >
            Pay
          </button> */}
          <button
            type="button"
            className={`btn mg-right ${
              showSelectCredit ? 'display-block' : 'display'
            }`}
            disabled={disabledbtn}
            onClick={selectClick}
          >
            {i18n.t('common.continueActionTxt')}
          </button>
          <button
            className={`btn mg-right ${
              showContinue ? 'display-block' : 'display'
            }`}
            onClick={continueClick}
            disabled={continueDisabledbtn}
          >
            {i18n.t('common.continueActionTxt')}
          </button>
        </div>
      </div>
    );
  };

  const findDuplicates = (allselctValue: any) => {
    const obj = {};
    for (let i = 0, len = allselctValue.length; i < len; i++) {
      obj[allselctValue[i]['invoiceNumber']] = allselctValue[i];
    }
    allselctValue = new Array();
    for (const key of Object.keys(obj)) {
      allselctValue.push(obj[key]);
    }
    return allselctValue;
  };

  React.useEffect(() => {
    const debitInvoices: any = [];
    const creditInvoices: any = [];
    const debitStatusData: any = [];
    const creditStatusData: any = [];
    let totalCreditAmt = 0;
    const statusData: any = [];
    let totalRemainingAmount = 0;
    let checkCreditVal = false;

    if (selectedImproperData.length > 0) {
      handleShowCustomToolBar(true);
      setShowSelectcredit(false);
      setHideBtnShowError(
        i18n.t(
          'invoices.toperformanytransactiontheinvoicesyouselectmustbeOpenorPastDueand'
        )
      );
      setContinueDisabledbtn(false);
      setDisabledbtn(false);
      setShowcontinue(false);
      setHidepay(false);
    } else {
      if (allSelectedData && allSelectedData.length > 0) {
        allSelectedData.forEach((val: any) => {
          if (
            val.remainingAmount > 0 &&
            (debitInvoicesDocType.includes(val.documentType) ||
              bothCreditDebit.includes(val.documentType))
            // debitInvoicesDocType.includes(val.documentType) ||
            // (bothCreditDebit.includes(val.documentType) &&
            //   val.remainingAmount > 0)
          ) {
            debitInvoices.push(val);
            debitStatusData.push(val.status);
          } else if (
            val.remainingAmount < 0 &&
            (creditInvoicesDocType.includes(val.documentType) ||
              bothCreditDebit.includes(val.documentType))
            // creditInvoicesDocType.includes(val.documentType) ||
            // (bothCreditDebit.includes(val.documentType) &&
            //   val.remainingAmount <= 0)
          ) {
            creditInvoices.push(val);
            creditStatusData.push(val.status);
            totalCreditAmt += val.remainingAmount;
            if (val.remainingAmount === 0) {
              checkCreditVal = true;
            }
          }
          totalRemainingAmount += val.remainingAmount;
          statusData.push(val.status);
        });

        if (
          checkCreditVal ||
          debitStatusData.includes('PENDING') ||
          creditStatusData.includes('PENDING') ||
          debitStatusData.includes('IN PROCESS') ||
          creditStatusData.includes('IN PROCESS')
        ) {
          handleShowCustomToolBar(true);
          setShowSelectcredit(false);
          setHideBtnShowError(
            i18n.t(
              'invoices.toperformanytransactiontheinvoicesyouselectmustbeOpenorPastDueand'
            )
          );
          setContinueDisabledbtn(false);
          setDisabledbtn(false);
          setShowcontinue(false);
          setHidepay(false);
        } else {
          if (
            (creditStatusData.includes('OPEN') ||
              creditStatusData.includes('PAST DUE')) &&
            (debitStatusData.includes('PAST DUE') ||
              statusData.includes('OPEN')) &&
            totalCreditAmt < 0
          ) {
            handleShowCustomToolBar(true);
            setShowSelectcredit(false);
            setHideBtnShowError('');
            setContinueDisabledbtn(false);
            setDisabledbtn(false);
            setShowcontinue(true);
            setHidepay(false);
          }

          if (
            debitInvoices.length > 0 &&
            creditInvoices.length === 0 &&
            (statusData.includes('OPEN') || statusData.includes('PAST DUE'))
          ) {
            handleShowCustomToolBar(true);
            setShowSelectcredit(true);
            setHideBtnShowError('');
            setDisabledbtn(false);
            setShowcontinue(false);
            setHidepay(false);
          }

          if (
            creditInvoices.length > 0 &&
            debitInvoices.length === 0 &&
            (statusData.includes('OPEN') || statusData.includes('PAST DUE'))
          ) {
            handleShowCustomToolBar(true);
            setShowSelectcredit(false);
            setHideBtnShowError(
              i18n.t('invoices.pleaseSelectDebitInvoiceToContinue')
            );
            setContinueDisabledbtn(true);
            setShowcontinue(true);
            setHidepay(false);
          }
          if (
            totalRemainingAmount === 0 &&
            (statusData.includes('PAST DUE') ||
              statusData.includes('IN PROCESS') ||
              statusData.includes('PENDING'))
          ) {
            handleShowCustomToolBar(false);
          }
        }

        // if (
        //   checkCreditVal ||
        //   debitStatusData.includes('PENDING') ||
        //   creditStatusData.includes('PENDING') ||
        //   debitStatusData.includes('IN PROCESS') ||
        //   creditStatusData.includes('IN PROCESS') ||
        //   debitStatusData.includes('PAID') ||
        //   creditStatusData.includes('PAID') ||
        //   creditStatusData.includes('OPEN')
        // ) {
        //   handleShowCustomToolBar(true);
        //   setShowSelectcredit(false);
        //   setHideBtnShowError(
        //     'To perform any transaction, you must select only debit invoices that are Open or Past Due.'
        //   );
        //   setContinueDisabledbtn(false);
        //   setDisabledbtn(false);
        //   setShowcontinue(false);
        //   setHidepay(false);
        // } else {
        //   if (
        //     (creditStatusData.includes('OPEN') ||
        //       creditStatusData.includes('PAID')) &&
        //     (debitStatusData.includes('PAST DUE') ||
        //       statusData.includes('OPEN')) &&
        //     totalCreditAmt < 0
        //   ) {
        //     handleShowCustomToolBar(true);
        //     setHideBtnShowError(
        //       'You must select only debit invoices to apply credit or pay for them.'
        //     );
        //     setShowSelectcredit(false);
        //     setHideBtnShowError('');
        //     setContinueDisabledbtn(false);
        //     setDisabledbtn(false);
        //     setShowcontinue(false);
        //     setHidepay(false);
        //   }

        //   if (
        //     debitInvoices.length > 0 &&
        //     creditInvoices.length === 0 &&
        //     (statusData.includes('OPEN') || statusData.includes('PAST DUE'))
        //   ) {
        //     handleShowCustomToolBar(true);
        //     setShowSelectcredit(false);
        //     setHideBtnShowError('');
        //     setDisabledbtn(false);
        //     setShowcontinue(true);
        //     setHidepay(false);
        //   }

        //   if (
        //     creditInvoices.length > 0 &&
        //     debitInvoices.length === 0 &&
        //     (statusData.includes('OPEN') || statusData.includes('PAID'))
        //   ) {
        //     handleShowCustomToolBar(true);
        //     setShowSelectcredit(false);
        //     setHideBtnShowError(
        //       'You must select only debit invoices to apply credit or pay for them.'
        //     );
        //     setContinueDisabledbtn(false);
        //     setShowcontinue(false);
        //     setHidepay(false);
        //   }
        //   if (
        //     totalRemainingAmount === 0 &&
        //     (statusData.includes('PAID') ||
        //       statusData.includes('IN PROCESS') ||
        //       statusData.includes('PENDING'))
        //   ) {
        //     handleShowCustomToolBar(false);
        //   }
        // }
      } else {
        setHideBtnShowError('');
      }
    }
  }, [allSelectedData]);

  const onRowSelectionChange = (
    currentRowsSelected: any,
    allRowsSelected: any,
    rowsSelectedpath: any
  ) => {
    if (currentRowsSelected.length === 0) {
      setRowscount([]);
      // props.isChecked([]);
      // setAllSelectedData([]);
      // setHideBtnShowError('');
      // allSelectedData.splice(indexInv, 1);
      console.log('allSelectedData>1>', allSelectedData);
      // const afterRemove = _.remove(allSelectedData, obj => props.invoiceData.indexOf(obj.invoiceNumber && obj.previousInvoice) > -1);
      // console.log('allSelectedData>2>', allSelectedData,afterRemove);
      const propData: any[] = props.invoiceData;
      propData.forEach(e => {
        const indexInv = allSelectedData.findIndex(
          el =>
            el.invoiceNumber === e.invoiceNumber &&
            el.previousInvoice === e.previousInvoice
        );
        allSelectedData.splice(indexInv, 1);
      });
      console.log('allSelectedData>2>', allSelectedData);
      viewAllSelectedOnce(allSelectedData);
    } else {
      const selections: any[] = [];
      const allSelections: any[] = [];
      const selectedCredit: any[] = [];
      setRowscount(rowsSelectedpath);
      //  const selections:any[] = [];
      rowsSelectedpath.map((index: any) => {
        // DebitInvoices

        if (props.invoiceData.length > 0) {
          const obj = {
            invoiceNumber: props.invoiceData[index].invoiceNumber,
            invoiceDate: props.invoiceData[index].invoiceDate,
            totalAmount: props.invoiceData[index].remainingAmount,
            paymentAmount: props.invoiceData[index].remainingAmount,
            remainingAmount: props.invoiceData[index].remainingAmount,
            orderNumber: props.invoiceData[index].orderNumber,
            transactionId: props.invoiceData[index].transactionId,
            previousInvoice: props.invoiceData[index].previousInvoice,
            dueDate: props.invoiceData[index].dueDate,
            status: props.invoiceData[index].status,
            documentType: props.invoiceData[index].documentType
          };
          allSelections.push(obj);
          // if (props.invoiceData[index].remainingAmount > 0) {
          //   selections.push(obj);
          //   allSelections.push(obj);
          // } else if (props.invoiceData[index].remainingAmount === 0) {
          //   allSelections.push(obj);
          // }
        }

        // CreditInvoices

        // if (
        //   props.invoiceData.length > 0 &&
        //   props.invoiceData[index].remainingAmount < 0
        // ) {
        //   const creditobj = {
        //     invoiceNumber: props.invoiceData[index].invoiceNumber,
        //     invoiceDate: props.invoiceData[index].invoiceDate,
        //     totalAmount: props.invoiceData[index].remainingAmount,
        //     paymentAmount: props.invoiceData[index].remainingAmount,
        //     remainingAmount: props.invoiceData[index].remainingAmount,
        //     orderNumber: props.invoiceData[index].orderNumber,
        //     transactionId: props.invoiceData[index].transactionId,
        //     status: props.invoiceData[index].status,
        //     documentType: props.invoiceData[index].documentType
        //   };
        //   selectedCredit.push(creditobj);
        //   allSelections.push(creditobj);
        // }
        // setCreditdata(selectedCredit);
      });
      if (currentRowsSelected && currentRowsSelected.length > 0) {
        const indexCheck = rowsSelectedpath.findIndex(
          (ele: any) => ele === currentRowsSelected[0].index
        );
        if (
          allSelectedData &&
          allSelectedData.length > 0 &&
          indexCheck === -1
        ) {
          const currentInvoiceData =
            props.invoiceData[currentRowsSelected[0].index];
          const indexInv = allSelectedData.findIndex(
            el =>
              el.invoiceNumber === currentInvoiceData.invoiceNumber &&
              el.previousInvoice === currentInvoiceData.previousInvoice
          );
          const val = allSelectedData.splice(indexInv, 1);
        }
      }
      // console.log('selections3>>>>>',selections,selectedData);
      // setSelectedData(selections);
      // console.log('selections4>>>>>',selections,selectedData);
      // _.reject(rooms, { channel: 'room-a', name: 'test' });
      const selectVal = allSelectedData.concat(allSelections);
      const finalSelectedData = _.uniqWith(selectVal, _.isEqual); // findDuplicates(selectVal);
      viewAllSelectedOnce(finalSelectedData);
    }
  };
  const viewAllSelectedOnce = (data: any) => {
    let newDebitAmount = 0;
    let newCreditAmount = 0;
    let totalRemainingAmount = 0;
    const finalSelectedData: any[] = data;
    const allSelectedDebitData: any[] = [];
    const allSelectedCreditData: any[] = [];
    const allSelectedImproperDebitCreditData: any[] = [];
    const allinvoiceNumber: any[] = [];
    finalSelectedData.forEach((ele: any) => {
      const remainingAmount = ele.remainingAmount;
      const docType = ele.documentType;
      const invoiceNumber = ele.invoiceNumber;
      if (
        remainingAmount > 0 &&
        (debitInvoicesDocType.includes(docType) ||
          bothCreditDebit.includes(docType))
      ) {
        allSelectedDebitData.push(ele);
        newDebitAmount += remainingAmount;
      }
      if (
        remainingAmount < 0 &&
        (creditInvoicesDocType.includes(docType) ||
          bothCreditDebit.includes(docType))
      ) {
        allinvoiceNumber.push({
          invoicenum: invoiceNumber,
          remaningamount: remainingAmount
        });
        allSelectedCreditData.push(ele);
      }

      if (
        remainingAmount === 0 ||
        (remainingAmount < 0 && debitInvoicesDocType.includes(docType)) ||
        (remainingAmount > 0 && creditInvoicesDocType.includes(docType))
      ) {
        allSelectedImproperDebitCreditData.push(ele);
      }

      // if (remainingAmount >= 0) {
      //   newDebitAmount += remainingAmount;
      // } else {
      //   newCreditAmount += remainingAmount;
      // }
      totalRemainingAmount += remainingAmount;
    });
    const unique: any[] = [];
    const uniqueCreditDate: any[] = [];
    const distinctuniqueCreditDate: any[] = [];
    let i;
    for (i = 0; i < allinvoiceNumber.length; i++) {
      if (!unique[allinvoiceNumber[i].invoicenum]) {
        unique[allinvoiceNumber[i].invoicenum] = 1;
        newCreditAmount += allinvoiceNumber[i].remaningamount;
      }
    }
    let j;
    for (j = 0; j < allSelectedCreditData.length; j++) {
      if (!uniqueCreditDate[allSelectedCreditData[j].invoiceNumber]) {
        uniqueCreditDate[allSelectedCreditData[j].invoiceNumber] = 1;
        distinctuniqueCreditDate.push(allSelectedCreditData[j]);
      }
    }
    // console.log('distinctuniqueCreditDate', distinctuniqueCreditDate);
    props.isChecked(finalSelectedData);
    setAllSelectedData(finalSelectedData);
    setSelectedImproperData(allSelectedImproperDebitCreditData);
    setSelectedData(allSelectedDebitData);
    setCreditdata(distinctuniqueCreditDate);
    setDebitamount(newDebitAmount);
    setCreditamount(newCreditAmount);

    /// first check doc type then remaning amt
    // if rem <0 - credit else debit
  };
  const options = {
    filter: false,
    search: false,
    download: false,
    disableToolbarSelect: true,
    rowsSelected: rowscount,
    pagination: false,
    print: false,
    sort: true,
    fixedHeader: false,
    responsive: 'standard' as Responsive,
    draggableColumns: {
      enabled: true,
      transitionTime
    },
    sortOrder: sortOrderState as any,
    onRowSelectionChange,
    customToolbarSelect: () => <CustomToolbar />,
    customToolbar: () => (
      <MuiThemeProvider theme={theme}>
        <span className="export-icon">
          <Button
            aria-controls="fade-menu"
            aria-haspopup="true"
            onClick={handleClickListItem}
            disabled={!allSelectedData.length && !props.invoiceData.length}
          >
            <img className="image-icon" src={exportIcon} />
            <img className="down-arrow" src={downarrowIcon} />
          </Button>
        </span>
        <span className="export-icon save-icon">
          <Button
            onClick={handleDownloadListItem}
            disabled={!allSelectedData.length}
          >
            <img className="image-icon" src={saveFileIcon} />
          </Button>
        </span>
        <span className="export-icon email-icon">
          <Button onClick={openEmailModal} disabled={!allSelectedData.length}>
            <img className="image-icon" src={emailIcon} />
          </Button>
        </span>
        <Menu
          id="fade-menu"
          anchorEl={anchorEl}
          keepMounted={true}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          {exportOptions.map((exportoptions, index) => (
            <MenuItem
              key={exportoptions.value}
              // selected={index === index}
              onClick={event => handleMenuItemClick(event, index)}
            >
              {exportoptions.label}
            </MenuItem>
          ))}
        </Menu>
        <div className="rp-product-status--paginator">
          <CustomPaginator
            activePage={
              props.pagination.pageNumber ? props.pagination.pageNumber + 1 : 1
            }
            totalPages={props.pagination.totalPages}
            itemsPerPage={props.pagination.pageSize}
            onPageChanged={handlePagination}
            totalItems={props.pagination.totalPages * props.pagination.pageSize}
            showPageInfo={true}
            onPageSizeChange={handlePageSizeChange}
            showPageRangeChange={true}
            currentPageSize={props.pagination.pageSize}
          />
        </div>
        <React.Fragment>
          {hideBtnShowError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setHideBtnShowError('');
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              {hideBtnShowError}
            </Alert>
          ) : (
            ''
          )}
          {showInvoiceError ? (
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setShowInvoiceError(false);
                  }}
                >
                  <MatrialCloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
            >
              <div>
                {/* {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message12')}
                    <a href="mailto:reliablepartsar1@reliableparts.com">
                      reliablepartsar1@reliableparts.com
                    </a>{' '}
                  </div>
                ) : (
                  <div className="error-message-to-show">
                    {i18n.t('invoices.message12')}
                    <a href="mailto:accounts.receivable.us@reliableparts.com">
                      accounts.receivable.us@reliableparts.com
                    </a>{' '}
                  </div>
                )} */}
              </div>
              <div className="error-message-to-show">
                {i18n.t('invoices.downloaderror')}
              </div>
            </Alert>
          ) : (
            ''
          )}
        </React.Fragment>
        {allSelectedData.length > 0 && <CustomToolbar />}
      </MuiThemeProvider>
    ),
    onViewColumnsChange: (changedColumn: any, action: any) => {
      // console.log("onViewColumnsChange");
      // console.log(changedColumn, action);
      checkDisplayState(changedColumn, action === 'add' ? true : false, true);
    },
    onColumnSortChange: (changedColumn: string, direction: string) => {
      // console.log("onColumnSortChange");
      // console.log(changedColumn, direction);
      const dir = direction;
      setSortOrderState({ name: changedColumn, direction: dir });
      handleSorting({ type: changedColumn, order: dir });
    },
    textLabels: {
      body: {
        toolTip: `${i18n.t('invoices.sort')}`
      }
    }
  };
  return (
    <React.Fragment>
      <div className="section-loader">
        {showDownloadLoaderOnAction ? (
          <Downloadloader />
        ) : showLoaderOnAction ? (
          <div className="loader-container">
            <div className="loader-content">
              {i18n.t('invoices.pleasewaitwhileweareprocessingyourrequest')}
            </div>
            <div className="loader loader-position" />
          </div>
        ) : (
          ''
        )}
        {props.isPending ? (
          <div className="loader-container">
            <div className="loader" />
          </div>
        ) : (
          <div className="invoiceTable">
            {/* <div onClick={checkPDF}>abc</div> */}
            <MuiThemeProvider theme={theme}>
              <MUIDataTable
                title={''}
                data={invoiceData.map((item: any) => {
                  return [
                    item.invoiceNumber,
                    item.transactionId,
                    item.invoiceDate,
                    item.orderNumber,
                    item.poNumber,
                    item.description,
                    item.previousInvoice,
                    item.nardaNumber,
                    item.totalAmount,
                    item.remainingAmount,
                    item.dueDate,
                    item.status,
                    item.documentType
                  ];
                })}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </div>
        )}
        {getEmailModal()}
      </div>
    </React.Fragment>
  );
}

export default EnhancedTable;
